import app from 'flarum/forum/app';

/**
 * 官网文案的统一读取入口。
 *
 * ⚠️ 为什么不能直接用 `flarum/common/helpers/i18n` 的 t():
 *   1) Flarum 2.0 的 translator.trans() 在部分 key 上会返回 vnode 数组 ⇒ 拍平成字符串;
 *   2) locale 里写 YAML 数组时, Symfony 的 ArrayLoader::flatten 会把它拍平成
 *      "key.0" / "key.1" / ... (列表里是对象时是 "key.0.title" 这种),
 *      而 trans() 只认完整 key ⇒ 列表要用下面 tList / tItems 读。
 *
 * ⚠️ 另外: Flarum 只把 `...forum.` / `...lib.` 段的翻译键下发给 forum 前端
 *   (Flarum\Frontend\AddTranslations::forFrontend 的过滤器)
 *   ⇒ 官网文案必须放在 locale 的 forum: 下面, 否则浏览器端根本收不到。
 */

const PREFIX = 'ziven-geewen-site.forum.';

/**
 * 取一条翻译 (纯文本)。
 *
 * @param {string} key forum. 之后的键名, 如 'nav.products'
 * @returns {string}
 */
export function t(key) {
  const value = app.translator.trans(PREFIX + key);
  return Array.isArray(value) ? value.join('') : value;
}

/**
 * 取一个「标量列表」型翻译 (locale 里写成 YAML 数组)。
 *
 * @param {string} key 如 'products.scheduler.modules'
 * @returns {string[]}
 */
export function tList(key) {
  const all = app.translator.translations;
  const out = [];
  for (let i = 0;; i++) {
    const flatKey = PREFIX + key + '.' + i;
    if (!Object.prototype.hasOwnProperty.call(all, flatKey)) break;
    out.push(all[flatKey]);
  }
  return out;
}

/**
 * 取一个「对象列表」型翻译 (每项若干子键, 如 features[].icon/title/desc)。
 *
 * @param {string} key 如 'products.scheduler.features'
 * @param {string[]} fields 该项的子键, 第一个用于探测列表长度
 * @returns {object[]}
 */
export function tItems(key, fields) {
  const all = app.translator.translations;
  const out = [];
  for (let i = 0;; i++) {
    const prefix = PREFIX + key + '.' + i + '.';
    if (!Object.prototype.hasOwnProperty.call(all, prefix + fields[0])) break;
    const item = {};
    fields.forEach(field => {
      item[field] = all[prefix + field];
    });
    out.push(item);
  }
  return out;
}
flarum.reg.add('ziiven-geewen-site', 'forum/helpers/i18i18n', { t: t,tList: tList,tItems: tItems, });